module.exports = __webpack_public_path__ + "img/四川天府新区大林小学（玉皇博爱校区）.3c732747.jpg";